export enum MapId {
  AssetLocationMap = 'assetLocationMap',
  PoiFullScreenMap = 'poiFullScreenMap',
  AssetsMap = 'assetsMap',
  AssetLogMap = 'assetLogMap',
  FleetMap = 'fleetMap',
  OnCallMap = 'onCallMap',
  OnCallLocationMap = 'onCallLocationMap',
  POIMap = 'poiMap',
  FleetLocationMap = 'fleetLocationMap',
  FleetLocationFullScreenMap = 'fleetLocationFullScreenMap',
  MergeTripMap = 'mergeTripMap',
  TripInfoMap = 'tripInfoMap',
  TripOnMapTabMap = 'tripOnMapTabMap',
  NewPoiMap = 'newPoiMap',
  WarehouseTrackerMap = 'warehouseTrackerMap',
  TrackersMap = 'trackersMap',
  VehiclesMap = 'vehiclesMap',
  SingleVehicleMap = 'singleVehicleMap',
  PredefinedGeofenceMap = 'predefinedGeofenceMap',
  RouteNetworksMap = 'routeNetworksMap',
  RouteNetworkMarkerMap = 'routeNetworkMarkerMap',
}
